import { createContext, useContext } from 'react';
import { Map as ImmutableMap } from 'immutable';
import emptyFunction from 'react-utils/emptyFunction';

/**
 * Context for storing which emails in a thread are expanded/collapsed
 *
 * @param {object}   value
 *
 * @param {Map}      value.emailsToExpand                a map of emails in a thread with keys as engagement ids
 *                                                       and values of booleans representing whether the email is expanded
 *
 * @param {Function} value.handleCollapseAll             a callback that collapses all emails in thread
 *
 * @param {Function} value.handleExpandAll               a callback that expands all emails in thread

 * @param {number}   value.originalEngagementId          the number id of the email that the thread originated from
 *
 * @param {Function} value.setThreadedEmailIsExpanded    a callback that sets whether an email is expanded, accepting two
 *                                                       arguments: engagementId and isExpanded, a boolean representing whether
 *                                                       the email with the given engagementId is expanded
 */

export const ThreadedEmailContext = /*#__PURE__*/createContext({
  emailsToExpand: ImmutableMap(),
  handleCollapseAll: emptyFunction,
  handleExpandAll: emptyFunction,
  originalEngagementId: null,
  setThreadedEmailIsExpanded: emptyFunction
});
export const useThreadedEmailContext = () => useContext(ThreadedEmailContext);